export interface ProviderContact {
  name: string;
  email: string;
  phone: string;
  type: 'OWNER' | 'OPERATIONS';
}

export interface ProviderRegistration {
  commercialName: string;
  rfc: string;
  providerNumber: string;
  active: boolean;
  contacts: ProviderContact[];
}

export const ContactTypes = {
  OWNER: 'OWNER',
  OPERATIONS: 'OPERATIONS'
} as const;

export type ContactType = typeof ContactTypes[keyof typeof ContactTypes];